import { produce } from 'immer'
import baseReducer from '@utilities/base-reducer'
import * as Actions from './stepbar-action'
import { StepOrder } from '@constants/StepOrderEnum'

const initialState = {
  step: StepOrder.CompanyStep,
}

const stepBarReducer = baseReducer(initialState, {
  [Actions.NEXT_STEP](state) {
    return produce(state, draftState => {
      draftState.step = draftState.step + 1
    })
  },
  [Actions.BACK_STEP](state) {
    return produce(state, draftState => {
      draftState.step = draftState.step - 1
    })
  },
})

export default stepBarReducer
